import "./Footer.css";

function Footer() {
  return (
    <footer
      role="contentinfo"
      className="footer_main"
    >
      © Sumurai Dogg 2025. All Rights Reserved.
    </footer>
  );
}

export default Footer;
